import { render, staticRenderFns } from "./ConnectWalletMobile.vue?vue&type=template&id=82dfd1f4&scoped=true&"
import script from "./ConnectWalletMobile.vue?vue&type=script&lang=js&"
export * from "./ConnectWalletMobile.vue?vue&type=script&lang=js&"
import style0 from "./ConnectWalletMobile.vue?vue&type=style&index=0&id=82dfd1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dfd1f4",
  null
  
)

export default component.exports